// extracted by mini-css-extract-plugin
export var centerText = "_dw-8";
export var container = "_dw-0";
export var doughnutContainer = "_dw-7";
export var legend = "_dw-a";
export var legendItemColorDisplay = "_dw-b";
export var legendItemLabel = "_dw-d";
export var legendItemValue = "_dw-c";
export var lg = "_dw-5";
export var maxWidth = "_dw-9";
export var md = "_dw-4";
export var responsive = "_dw-6";
export var sm = "_dw-3";
export var xs = "_dw-2";
export var xxs = "_dw-1";